export default {
  categoryInfo: {
    mainTitle: 'Doğum Sigortası',
    description: {
      title: 'Doğum (Hamilelik) Sigortası Nedir?',
      content: [
        '“Hamilelik sigortası ne demek?” Sorusunu merak eden adaylar bu sayfamızdan geniş kapsamlı bilgilere ulaşabilir.',
        'Sağlık sigortası, hamilelik sırasında hem sizin hem de bebeğinizin sağlıklı kalmasına yardımcı olmak için tıbbi kontrolleri ve tarama testlerini yaptırmayı kolaylaştırır.',
        'Doğum teminatı olarak sağlık sigortası poliçelerine eklenmektedir. Hamilelikle ilgili tüm masrafları kapsayan planları değerlendirerek poliçenize ekleyebileceğiniz bir ek teminattır.'
      ]
    },
    subContent: {
      title: 'Doğum Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Doğum sigortası, hamile kadınlar için doğum öncesi bakım ve doğum hizmetleri dâhil olmak üzere birçok hizmeti kapsamaktadır. Tıbbi bakım için ödeme yapmanıza yardımcı olur. Hamilelik sigortası, özellikle hamile kalmayı planlıyorsanız, sizin için gerçekten önemlidir.',
          subList: null
        },
        {
          paragraph:
            'Doğum teminatı yalnızca doğum masrafları karşılamakla kalmaz, aynı zamanda yeni doğmuş bebeğinizi de doğumdan sonra yeni doğan teminatı ile poliçenize ekleme şansı sunar.',
          subList: null
        },
        {
          paragraph:
            'Doğum sigortası; hamilelik sürecindeki rutin kontrollerini, tahlil ve tetkiklerini, gebelik komplikasyonlarını, TORCH taramasını, NST ve ikili tarama testini, normal veya sezaryen doğuma ait masrafları karşılar. Planların kapsamı sigorta şirketlerine göre değişiklik gösterebilir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Doğum Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        company: require('@/assets/company-logos/demir-sigorta.png'),
        alt: 'Demir Sigorta',
        name: 'Doğum Sigortası',
        assurance: 'Aile İndirimi',
        desc: 'İhtiyaca Göre Sağlık Planları'
      },
      {
        id: 2,
        company: require('@/assets/company-logos/sompo-sigorta.png'),
        alt: 'Sompo Sigorta',
        name: 'Doğum Sigortası',
        assurance: 'Doğum + Yatarak Tedavi Teminatları',
        desc: 'Doğum + Rutin Muayene Paketi Planı İle Avantajlı Poliçe'
      },
      {
        id: 3,
        company: require('@/assets/company-logos/turk-nippon.png'),
        alt: 'Türk Nippon Sigorta',
        name: 'Doğum Sigortası',
        assurance: 'Hayata Merhaba  ',
        desc: 'Bekleme Süresiz Doğum Sigortası'
      }
    ]
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Doğum Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Doğum teminatı, normal ve sezaryen doğumu teminat altına almaktadır. Sigortanızın kapsamı tercih edeceğiniz doğum planına göre farklılık gösterecektir.',
          subList: null
        },
        {
          paragraph:
            'Doğum sigortası yaptırmanız sonucunda gebelik rutin kontrolleri, gebelik tahlil ve tetkikleri, gebelik komplikasyonları, normal doğum, sezaryen doğum ve oda masraflarınız teminat altında olur.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum Sigortası Ne Zaman Yapılmalı?',
      content: [
        {
          paragraph:
            '“Hamile kalmadan kaç ay önce sigorta yapılmalıdır?” Sorunuzun cevabı:',
          subList: null
        },
        {
          paragraph:
            'Bu öncelikle hayatın hangi evresinde olduğunuza bağlıdır. Bekârsanız ve en azından önümüzdeki iki ila üç yıl içinde evlenmeyi veya bebek sahibi olmayı planlamıyorsanız, doğum sigortası yaptırmanıza gerek yoktur. ',
          subList: null
        },
        {
          paragraph:
            'Bununla birlikte, evliyseniz veya yakında evlenecekseniz ve önümüzdeki iki yıl içinde bir aile kurmak isteyeceğinizi düşünüyorsanız, bekleme dönemini iyi bir şekilde karşılayacağınız için şimdi poliçenizi tercih etmeniz daha iyidir. ',
          subList: null
        },
        {
          paragraph:
            'Sigortacıların çoğu, hâlihazırda hamile olan kişilere doğum sigortası sağlamaz. Sigortacılar hamileliği önceden var olan bir durum olarak görürler, bu nedenle, annelik sigortası uzun bir bekleme süresiyle birlikte geldiğinden, bu poliçeyi mümkün olan en kısa sürede almalısınız.',
          subList: null
        },
        {
          paragraph:
            'Hamilelik sigortasında en kritik nokta, teminatın sigorta poliçesine dâhil edilme zamanıdır.',
          subList: null
        },
        {
          paragraph:
            'Doğum sigortası, gebe kalmadan <strong><em><u>en az 1 yıl</u></em></strong> öncesinden satın alınmalıdır. Aksi durumda değerlendirebileceğiniz doğum poliçesi sadece 3 şirket olacaktır. Bu nedenle, her zaman önceden planlamanızı ve kişisel sağlık sigortası poliçenizde erkenden doğum planınızı seçmenizi öneririz.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum (Gebelik) Sigortası Yaptırmak Mantıklı Mı?',
      content: [
        {
          paragraph:
            'İster yakın zamanda bir aile kurmayı planlıyor olun, ister mevcut çocuğunuza bağ kurması için bir kardeş planlıyor olun, annelik, doğum ve bununla birlikte gelen her şey genellikle stresli olabilir. ',
          subList: null
        },
        {
          paragraph:
            'Biz tam da bu aşamada size yardımcı olmak için buradayız. Zamanından önce. ',
          subList: null
        },
        {
          paragraph:
            'Sonuçta, yalnızca planlanmamışlar için değil, planlananlar için de plan yapmak her zaman daha iyidir. Sadece hastane masrafları için değil, psikolojik olarak da rahat edebilmeniz için uzmanlar doğum sigortası yaptırmanızı önermektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Annelik Sigortası Kapsamını Seçerken Kaçınılması Gereken Hatalar Nelerdir?',
      content: [
        {
          paragraph:
            '<strong><em><u>Sigortayı çok geç almak:</u></em></strong> Yani hamile kalmadan iki ila üç ay önce veya hamileliğiniz sırasında tercih etmek. Bu durumda, tam istediğiniz kapsama ulaşamayabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Sigortalı tutarı kontrol etmemek:</u></em></strong> Bu teminatın birincil kullanımı, hamileliğiniz sırasında ortaya çıkan masrafların karşılanmasıdır. Bu nedenle, sigorta teminat limitlerinizi kontrol etmeli ve yeterli olup olmayacağını değerlendirmeniz önemlidir.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Bekleme süresi bitmeden talepte bulunmak:</u></em></strong> İlgili teminatlarınızı talep etmeden önce bekleme sürelerini kontrol etmeniz önemlidir. Ancak gerekli doğum sigortası bekleme süresi dolduktan sonra ilgili masraflar için talepte bulunabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Hamilelik Rutin Muayene Teminatı Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Rutin muayene doğum sigortası kapsamında yer alır ve ilgili işlemler bu teminattan karşılanır. Rutin gebelik test ve tetkiklerini içerir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Doğum Sigortası Kapsamında Doğum Teminatında Ve Hamilelik Rutin Muayene Teminatında; Bekleme Süresi Uygulanacak Mı?',
      content: [
        {
          paragraph:
            'Doğum teminatlarının çoğunda bekleme süresi talep edilmektedir. Hamile kalmayı planlıyorsanız bekleme süresi olan doğum sigortalarını değerlendirebilirsiniz. Hamileyseniz, bekleme süresiz planları değerlendirmelisiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Hamilelik Rutin Muayenede, SGK Katılım Payı Ödenmesi Gerekiyor Mu?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında alınan doğum teminatından yararlanırken 15 TL’lik katılım payı ödemesi yapılmaktadır. (Yıllık bazda bu tutar değişiklik gösterebilir.)',
          subList: null
        }
      ]
    },
    {
      title: 'Hamilelere Özel Doğum Sigortası Ek Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Doğum teminatı sayesinde; gebelik süresi boyunca gerekli olan tüm rutin takip ve tetkikler ile beraber doğum anında ameliyathanenin kullanılması, doğum sırasında oluşan hastalıklar gibi giderler uygun maliyetlerle karşılanır.',
          subList: null
        },
        {
          paragraph:
            'Hayatınızın en önemli anlarından birinde finansal olarak güvende kalın. ',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortanızdaki doğum teminatı, birikimlerinizden çok fazla harcama yapmanıza gerek kalmamasını sağlayacak ve stressiz bir doğum ve ebeveynlik başlangıcına sahip olmanızı sağlayacaktır.',
          subList: null
        },
        {
          paragraph:
            'Doğum ve hamilelik sürecinde hastaneden alacağınız hizmetler doğrultusunda stresinizi en aza indirir, sadece doğum sürecinize odaklanmanızı sağlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum (Hamilelik) Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Doğum sigortası, Bireysel Sağlık Sigortası planlarımız dâhilinde bir eklenti olarak sağlık sigortası poliçeniz ile satın alınabilir. Tercih edeceğiniz doğum teminatlı planları ister özel sağlık sigortanıza ister tamamlayıcı sağlık sigortasına ekleyebilirsiniz. Bunun dışında bekleme süresiz doğum sigortası da alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sağlık planınızı seçerken plan özetine bakmalısınız. Her planın, gebelik bakımının beklenen maliyetlerini içeren bir özeti vardır. Her plan aynı özet formunu kullanır, bu nedenle maliyetleri ve hizmetleri karşılaştırmak kolaydır. Sağlık uzmanlarımız doğum sigortanızı seçerken yanınızda!',
          subList: null
        },
        {
          paragraph:
            'Doğum paketi adı altında sunacağımız sigorta tekliflerini değerlendirmeniz sonucunda teklifler arasında en iyisini seçmenize de yardımcı oluyoruz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bekleme Süresiz Doğum Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bekleme süresiz doğum sigortası, hamileliği başlamış olan anne adaylarının tercih edebileceği plandır.',
          subList: null
        },
        {
          paragraph:
            'Bekleme süresi bulunmayan doğum sigortası kapsamında isminden de anlaşılacağı üzere bir süre talep edilmez. Hamileyken yaptırılabildiği gibi gebeliğin 9. Ayında dahi yaptırılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Tamamlayıcı Sağlık Sigortası Doğum Paket Nedir?',
      content: [
        {
          paragraph:
            '“Tamamlayıcı sağlık sigortası doğumu karşılar mı?” sorusu aklınıza geliyor olabilir. Evet, tamamlayıcı sağlık sigortası doğum paketi olarak gündemde yer alan bu plan, sigorta şirketinin anlaşmalı özel hastanelerinde gebelik sürecinde ve doğum sırasındaki masrafları güvence altına alır.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası doğum paketi, özel hastanelerdeki doğum ücretlerinin artması sonucunda yoğun olarak ilgi gören bir pakettir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortası Doğum Paket Ürününe Kimler Sahip Olabilir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası satın almak isteyen adaylar öncelikle T.C. vatandaşı olmalı ve SGK kapsamında yer almalıdır. Bunun dışında sigorta şirketlerinin belirlemiş olduğu yaş sınırları vardır. Yaş sınırlarına uyum sağlayanlar bu plana sahip olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Doğum Paket Nedir?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası doğum paketi doğum masraflarını güvence altına alan sigorta ürünüdür. Özel sağlık sigortası kapsamında yer alan teminatlar, tamamlayıcı sağlık sigortasına göre daha geniş kapsamlı ve pahalıdır. ',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası doğum paketine sahip olmak kendinizi avantajlı hissetmenizi sağlar. Doğum masraflarınızı güvence altına almak için özel sağlık sigortası kapsamında doğum teminatına sahip olmak istiyorsanız, 5 ay ila 12 ay arasında şirketlere göre değişiklik gösteren bekleme süresinin olduğunu bilmelisiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Doğum Sigortası Seçerken Göz Önünde Bulundurulması Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Bu, hamilelik sırasında aldığınız tıbbi bakımdır. Sunulan hizmetler hamile kadınları kapsanmaktadır. Doğum sigortası alırken dikkat etmeniz gereken adımlar:',
          subList: null
        },
        {
          paragraph:
            '<ol><li>Bekleme süresi,</li><li>Poliçe kapsamı,</li><li>Teminat limitleri,</li><li>Katkı payı,</li><li>Sunulan indirimler,</li><li>Günlük bakım tedavileri,</li><li>Hastaneye yatış ve sonrası hizmetler,</li><li>Prim maliyeti,</li><li>Yeni doğan bebek teminatı sunulup sunulmadığıdır.</li></ol>',
          subList: null
        },
        {
          paragraph:
            'Bir aile kurmayı planlarken bir doğum sigortası almak, finansal strese girmenizi engeller.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum Sigortası Hem Normal Hem De Sezaryende Geçerli Mi? ',
      content: [
        {
          paragraph:
            'Evet, doğum sigortası yaptırmanız sonucunda gebelik rutin kontrolleri, gebelik tahlil ve tetkikleri, gebelik komplikasyonları, normal doğum, sezaryen doğum ve oda masraflarınız teminat altındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Hamileyken Doğum Sigortası Alınır Mı?',
      content: [
        {
          paragraph: 'Hamileyken doğum sigortası satın alabilirsiniz. ',
          subList: null
        },
        {
          paragraph: 'Hamileyken yaptırılabilecek doğum sigorta paketleri:',
          subList: [
            'Demir Hayat-İki Can ',
            'Türk Nippon-Hayata Merhaba',
            'Sompo Tamamlayıcı Sağlık Doğum Paket Sigortasıdır.'
          ]
        }
      ]
    },
    {
      title: 'Yeni Doğan Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Yeni doğan teminatı bebeğinizi güvence altına alan teminattır. Doğumdan sonra meydana gelebilecek komplikasyonlar için teminat sunar. ',
          subList: null
        },
        {
          paragraph:
            'Yeni doğan teminatını özel sağlık sigortası kapsamına ekletebilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum Sigortası Bekleme Süresi Nedir?',
      content: [
        {
          paragraph:
            'Genel olarak, bekleme süresi bir şirketten diğerine farklılık gösterir. 5 aydan 12 aya kadar değişir. ',
          subList: null
        },
        {
          paragraph:
            'Öyleyse, doğum teminatınız için bekleme süreniz 1 yıl ise, bu, poliçenizin annelik teminatından yararlanabilmeniz için satın aldığınız günden itibaren 1 yıl beklemeniz gerektiği anlamına gelir.',
          subList: null
        }
      ]
    },
    {
      title: 'Hamilelik Sigortasında Yenileme Güvencesi Hakkı Var Mı?',
      content: [
        {
          paragraph: 'Doğum teminatı kapsamında yenileme bulunmamaktır. ',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık ya da özel sağlık sigortası kapsamında alınan ek teminatlarda doğum gerçekleştikten sonra poliçenizi doğum teminatsız yenileyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Hamilelere Özel Doğum Sigortası Nerelerde Geçerli?',
      content: [
        {
          paragraph:
            'Doğum sigortasının geçerli olduğu anlaşmalı hastaneler sigorta şirketlerine göre değişiklik göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Doğum sigortası anlaşmalı hastaneleri öğrenmek için fiyat teklifi alabilirsiniz. Bu noktada uzmanlarımız size gerekli tüm detaylı iletir. Özellikle tercih etmek istediğiniz bir hastane varsa fiyat araştırması sırasında uzmanlarımızla paylaşabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Hamilelere Özel Doğum Sigortası Yaptırılmalıdır?',
      content: [
        {
          paragraph:
            'Sağlık maliyetleri sadece yükselirken, yeni doğmuş bir bebeği doğurmanın tıbbi maliyetleri de gün geçtikçe artmaktadır. Özellikle sezaryen veya diğer gebelik komplikasyonları varsa. ',
          subList: null
        },
        {
          paragraph:
            'Bununla birlikte, mali yükünüzü azaltarak ve güzel bebeğinizin doğumuna kadar her şeyin sorunsuz ve stressiz olmasını sağlayarak sizin ve eşinizin işlerini kolaylaştıracaktır.',
          subList: null
        },
        {
          paragraph:
            'Sonuçta, o sizin neşe kaynağınız olacak ve bu mutluluk anlarını sonuna kadar değerlendirip yaşayabilmenizi sağlamak istiyoruz. Güvenilir hizmet ve stressiz bir doğum süreci için bile hamilelik sigortası almaya değer!',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Doğum Sigortası Hangisidir?',
      content: [
        {
          paragraph:
            'Hamilelik için en iyi sağlık sigortası, gelirinize ve sağlık sigortası kapsamında almak istediğiniz hizmetlere göre belirlenir. Hamilelik için en uygun fiyatlı seçenekleri sunan sağlık sigortası planları vardır.',
          subList: null
        },
        {
          paragraph:
            'Yararlanmak istediğiniz durumları göz önünde bulundurarak sizin için en iyi kapsamı uzmanlarımız belirler!',
          subList: null
        }
      ]
    },
    {
      title: 'Gebelik Rutin Kontrolleri Nedir?',
      content: [
        {
          paragraph:
            'Gebelikte yapılacak rutin kontroller son derece önemlidir. Kontrollerin düzenli yaptırılması oluşabilecek sorunların erken çözüme kavuşturulmasını sağlar.',
          subList: null
        },
        {
          paragraph:
            'Genellikle gebeliğin erken döneminde aşağıdaki testler rutin olarak yapılır:',
          subList: [
            'Cinsel yolla bulaşan enfeksiyon taraması',
            'Hepatit B ve C taraması',
            'HIV taraması',
            'İdrar kültürü',
            'Kan grubu ve Rh',
            'Kızamıkçık ( rubella) taraması',
            'Tam idrar tetkiki',
            'Tam kan sayımı'
          ]
        }
      ]
    },
    {
      title: 'Gebelik Komplikasyonları Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Gebeliğin sebep olduğu her türlü komplikasyon – hiperemezis, abortus (zorunlu küretaj dâhil), preeklampsi vb. lohusalıkla ilgili sağlık giderleri, doğum ve sezaryene ait komplikasyonlar, poliçede belirtilen “Gebelik Komplikasyonları Tedavi” teminat limiti dahilinde karşılanır.',
          subList: null
        }
      ]
    },
    {
      title: '7/24 Destek Nasıl Alabilirim?',
      content: [
        {
          paragraph:
            'Alokasko.com sigorta danışmalarına dilediğiniz zaman ulaşım sağlayabilirsiniz. Bunun dışında web sitemizde online hizmet kanalı bulunmaktadır. Bilgilerinizi başvuru formuna doldurabilir ve sigorta şirketlerinin teminat karşılaştırmalarını yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum Sigortası Fiyatları Nasıl Hesaplanır?',
      content: [
        {
          paragraph:
            'Sigorta şirketinize teminat için aylık olarak ödeyeceğiniz para miktarına “prim” denir. Doğum sigortası ücretleri; yaşınıza, sağlık durumunuza, teminat limitlerinize, yaşadığınız yere göre hesaplanır.',
          subList: null
        },
        {
          paragraph:
            'Fazladan ödeme yapmaktan veya yapmamanız gereken bir şeyden kaçınmak için, sigorta şirketlerinin sunduğu doğum sigortası poliçelerini iyice anlamanız önemlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum (Hamilelik) Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Hamileliğinizin size neye mal olacağını mı merak ediyorsunuz? Nerede yaşadığınıza, nasıl doğum yaptığınıza ve sigortanız olup olmadığına bağlı olarak fiyatların çok geniş olduğunu öğrenmek sizi şaşırtabilir. Sağlık sigortası bu maliyetleri büyük ölçüde azaltabilir.',
          subList: null
        },
        {
          paragraph:
            'Size kesin bir fiyat verebilmeyi dilerdik, ancak doğum öncesi sağlık bakımı ve doğum maliyetleri kökten değişir. Ne kadar ödeyeceğiniz, yaşadığınız yer, herhangi bir komplikasyonunuz olup olmadığına veya sezaryen – normal gibi faktörlere bağlı olarak fark gösterecektir.',
          subList: null
        },
        {
          paragraph:
            'Hamilelik, sağlık sigortası olan kadınlar için bile yüksek maliyetli bir sağlık gideri olduğundan, genel maliyetlerinizi olabildiğince düşük tutmak için özellikle primlerin maliyetine odaklanmak isteyeceksiniz. Sizin için en uygun primi ve en uygun kapsamı uzmanlarımız bulacaktır, emin olabilirsiniz. Bunun için başvuru formunu doldurarak teklif alma adımlarını izleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum (Hamilelik) Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Hamilelik (doğum) sigortası fiyatlarını değerlendirmek için online teklif formunu doldurabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Hamilelik sürecindeki stresinizi düşünmeyin, geniş kapsamlı doğum sigortası satın alın, en iyi hizmetlerden yararlanın!',
          subList: null
        }
      ]
    }
  ]
}
